module.exports = "/images/KASMERE_BEZERRA.jpg?e546f643600e7d1a5d0ae7d7af0afa02";